import { render } from "./CroppedImageField.vue?vue&type=template&id=f0cf296c"
import script from "./CroppedImageField.vue?vue&type=script&lang=js"
export * from "./CroppedImageField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CroppedImageField.vue"]])

export default __exports__